module.exports = __webpack_public_path__ + "static/media/20ECE19.fa54055a.jpg";